import { jsx as _jsx } from "react/jsx-runtime";
import { TableCell, TableRow } from '@mui/material';
import { OTErrorBlock } from 'console/shared/components/banners/failure/components/ot-error';
export function OTFaultGroup(props) {
    const { ot_value, ot_state, boiler_model, boiler_type } = props;
    if (ot_value == null) {
        return null;
    }
    const { f, c } = ot_value;
    if (f.length == 0 && c == 0) {
        return null;
    }
    return (_jsx(TableRow, { hover: true, color: "error", children: _jsx(TableCell, { variant: "head", colSpan: 2, align: "center", children: _jsx(OTErrorBlock, { ot: ot_state, boiler_model: boiler_model, ba_protocol: boiler_type }) }) }));
}
